<template>
  <ChartTab
    :product="product"
    :product-data="productData"
    :subscription="subscription"
  />
</template>

<script lang="ts" setup>
import ChartTab from '~/components/price-assessments/ChartTab.vue'
import type { TProduct, TProductData } from '~/src/types/product.ts'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
  subscription: string
  productData: TProductData
}>()
</script>
